/* This example requires Tailwind CSS v2.0+ */
import { Fragment } from "react";
import { Disclosure, Menu, Transition } from "@headlessui/react";


import {IoMdArrowBack} from 'react-icons/io';
import { useNavigate } from 'react-router-dom';


export default function Navbar(Props) {
  let navigate =useNavigate()

  return (
    <Disclosure as="nav"  className={"mainBar"}>
        <>
          <div  className="max-w-7xl mx-auto px-2 sm:px-6 lg:px-8">
              <div onClick={()=>navigate('/')} style={{position:'absolute',left:20,top:12,backgroundColor:'rgba(211, 210, 211, 0.44)',borderRadius:100,padding:5,cursor:'pointer'}}>
      < IoMdArrowBack size={30} color='#000' />
    </div>
          
          </div>
       
             
        </>
    </Disclosure>
  );
}
